import React from 'react';
import { compose } from 'react-recompose';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import renderHtml, { renderHtmlWithoutHeight } from '../../../../lib/transformHtml';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import EditIcon from '@material-ui/icons/Edit';
import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall';
import ReplyAllIcon from '@material-ui/icons/ReplyAll';
import DeleteIcon from '@material-ui/icons/Delete';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import { DE as TextDE } from '../../../../lib/Text';
const styles = (theme) => ({
  gridExtended: {
    zIndex: 1,
    transition: 'z-index 33ms',
  },
  gridNotExtended: {
    zIndex: 0,
    transition: 'z-index 400ms',
  },
  cardRoot: {
    float: 'right',
    width: 'calc(100% - 2px)',
    backgroundColor: '#fffcdd',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100vw - 16px)',
    },
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      transition: 'width 400ms, margin-left 400ms',
    },
  },
  cardRootExtended: {
    float: 'right',
    backgroundColor: '#fffcdd',
    boxShadow: theme.shadows[16],
    [theme.breakpoints.up('md')]: {
      transition: 'width 400ms, margin-left 400ms',
      width: 'calc(110% - 2px)',
      marginLeft: '-10%',
    },
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: theme.spacing(0, 1),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 2),
      minWidth: theme.spacing(7),
      minHeight: theme.spacing(7),
      '&>svg': {
        minWidth: theme.spacing(5),
        minHeight: theme.spacing(5),
      },
    },
    flexShrink: 1,
  },
  collapseContainer: {
    borderTop: '1px solid #efefef',
    backgroundColor: '#fffcdd',
    flexGrow: 1,
  },
  paper: {
    backgroundColor: '#ffffff',
    minHeight: '40px',
    height: 'auto',
    overflow: 'auto',
    fontSize: '120%',
  },
  paperSmall: {
    backgroundColor: '#ffffff',
    height: '68px',
    maxHeight: '68px',
    overflow: 'clip',
    cursor: 'pointer',
    fontSize: '120%',
    padding: theme.spacing(1, 2) + '!important',
  },
});

const respondFunction = 1;
const editFunction = 2;
const deleteFunction = 3;

class FastNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = { openMenu: false, expanded: false };
  }

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded, openMenu: false }, () => {
      if (!!this.state.expanded) {
        this.props.expandScrollTo();
      }
    });
  };

  handleOpen = (event) => {
    this.setState({ openMenu: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ openMenu: false });
  };

  callback(type) {
    this.handleClose();
    if (type === editFunction) {
      this.props.editFunction(this.props.item);
    }
    if (type === respondFunction) {
      this.props.respondFunction(this.props.item);
    }
    if (type === deleteFunction) {
      this.props.deleteFunction(this.props.item);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid
        key={'note-list-' + this.props.index}
        item
        xs={12}
        md={10}
        classes={{ root: this.state.expanded ? classes.gridExtended : classes.gridNotExtended }}
      >
        <Card
          raised
          classes={{ root: this.state.expanded ? classes.cardRootExtended : classes.cardRoot }}
        >
          <Menu
            id='simple-menu'
            anchorEl={this.state.openMenu}
            open={Boolean(this.state.openMenu)}
            onClose={this.handleClose}
          >
            <MenuItem key={this.props.item.id + '-expandFunction'} onClick={this.toggleExpand}>
              <ListItemIcon>
                {this.state.expanded ? <PhotoSizeSelectSmallIcon /> : <AspectRatioIcon />}
              </ListItemIcon>
              <ListItemText
                primary={
                  this.state.expanded
                    ? TextDE.procedure.protocol.collapse
                    : TextDE.procedure.protocol.expand
                }
              />
            </MenuItem>
            {!!this.props.editFunction && (
              <MenuItem
                key={this.props.item.id + '-editFunction'}
                onClick={() => this.callback(editFunction)}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary={TextDE.procedure.protocol.edit} />
              </MenuItem>
            )}
            {!!this.props.respondFunction && (
              <MenuItem
                key={this.props.item.id + '-respondFunction'}
                onClick={() => this.callback(respondFunction)}
              >
                <ListItemIcon>
                  <ReplyAllIcon />
                </ListItemIcon>
                <ListItemText primary={TextDE.procedure.protocol.respond} />
              </MenuItem>
            )}
            {!!this.props.deleteFunction && (
              <MenuItem
                key={this.props.item.id + '-deleteFunction'}
                onClick={() => this.callback(deleteFunction)}
              >
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText primary={TextDE.delete} />
              </MenuItem>
            )}
          </Menu>
          <Collapse in={this.state.expanded} className={classes.collapseContainer}>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='center'
            >
              <Grid item style={{ flexGrow: 1 }}>
                {!!this.props.item.creator ? (
                  <Avatar
                    className={classes.avatar}
                    alt={
                      this.props.item.creator?.firstname + ' ' + this.props.item.creator?.lastname
                    }
                    src={
                      process.env.REACT_APP_API_URL +
                      '/avatar/' +
                      this.props.item.creator?.uuid +
                      '?thumb'
                    }
                  ></Avatar>
                ) : !!this.props.item.data?.creator ? (
                  <Avatar
                    className={classes.avatar}
                    alt={this.props.item.data?.creator?.name}
                    src={this.props.item.data?.creator?.avatar}
                  />
                ) : (
                  <Avatar className={classes.avatar}>
                    <EditIcon />
                  </Avatar>
                )}
              </Grid>
              <Grid item style={{ flexShrink: 1, paddingRight: '8px', paddingLeft: '8px' }}>
                <Hidden mdDown>
                  <Button
                    onClick={this.handleOpen}
                    fullWidth
                    variant='outlined'
                    color='primary'
                    startIcon={<MoreHorizIcon />}
                  >
                    {TextDE.procedure.protocol.more}
                  </Button>
                  <Tooltip
                    title={this.props.type.description}
                    aria-label={this.props.type.description}
                  >
                    <Box
                      fontSize='small'
                      component='div'
                      display='flex'
                      justifyContent='space-between'
                      mt={0.5}
                      mx={1}
                    >
                      Typ: {this.props.type.icon}
                    </Box>
                  </Tooltip>
                </Hidden>
                <Hidden lgUp>
                  <IconButton color='primary' aria-label='more' onClick={this.handleOpen}>
                    <MoreHorizIcon />
                  </IconButton>
                </Hidden>
              </Grid>
              <Grid item xs={12} style={{ flexGrow: 1 }}>
                <CardContent className={classes.paper}>
                  {renderHtml(
                    this.props.item.data?.body,
                    true,
                    () => {
                      return null;
                    },
                    true,
                  )}
                </CardContent>
              </Grid>
            </Grid>
          </Collapse>

          <Collapse in={!this.state.expanded} className={classes.collapseContainer}>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='center'
              style={{ flexWrap: 'nowrap' }}
            >
              <Grid item>
                {!!this.props.item.creator ? (
                  <Avatar
                    className={classes.avatar}
                    alt={
                      this.props.item.creator?.firstname + ' ' + this.props.item.creator?.lastname
                    }
                    src={
                      process.env.REACT_APP_API_URL +
                      '/avatar/' +
                      this.props.item.creator?.uuid +
                      '?thumb'
                    }
                  ></Avatar>
                ) : !!this.props.item.data?.creator ? (
                  <Avatar
                    className={classes.avatar}
                    alt={this.props.item.data?.creator?.name}
                    src={this.props.item.data?.creator?.avatar}
                  />
                ) : (
                  <Avatar className={classes.avatar}>
                    <EditIcon />
                  </Avatar>
                )}
              </Grid>
              <Grid item style={{ flexGrow: 1 }}>
                <CardContent onClick={this.toggleExpand} className={classes.paperSmall}>
                  {renderHtmlWithoutHeight(this.props.item.data?.body)}
                </CardContent>
              </Grid>
              <Grid item style={{ flexShrink: 1, paddingRight: '8px', paddingLeft: '8px' }}>
                <Hidden mdDown>
                  <Button
                    onClick={this.handleOpen}
                    fullWidth
                    variant='outlined'
                    color='primary'
                    startIcon={<MoreHorizIcon />}
                  >
                    {TextDE.procedure.protocol.more}
                  </Button>
                  <Tooltip
                    title={this.props.type.description}
                    aria-label={this.props.type.description}
                  >
                    <Box
                      fontSize='small'
                      component='div'
                      display='flex'
                      justifyContent='space-between'
                      mt={0.5}
                      mx={1}
                    >
                      Typ: {this.props.type.icon}
                    </Box>
                  </Tooltip>
                </Hidden>
                <Hidden lgUp>
                  <IconButton color='primary' aria-label='more' onClick={this.handleOpen}>
                    <MoreHorizIcon />
                  </IconButton>
                </Hidden>
              </Grid>
            </Grid>
          </Collapse>

          {this.state.expanded && (
            <CardActions disableSpacing={false}>
              <Button onClick={this.toggleExpand} fullWidth>
                <KeyboardArrowUpIcon />
              </Button>
            </CardActions>
          )}
        </Card>
      </Grid>
    );
  }
}

export default compose(withStyles(styles))(FastNote);
